import styled, { createGlobalStyle } from "styled-components";
import { device } from "./Device";

const GlobalStyle = createGlobalStyle`
*{
  box-sizing: border-box;
}

html {
  font-size: 11px;
  @media ${device.tablet} {
    font-size: 10px;
  }
}

body {
  background: #333;
  @media ${device.tablet} {
    background: white;
  }
}
`;
const CommunContainer = styled.div``;

const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${device.tablet} {
    margin-left: 10px;
  }
`;
const Items = styled.div`
  background-color: #f3f2ef;
  border-radius: 3px;
`;

const Flex = styled.div`
  display: flex;
  ${"" /* justify-content: ${(props) => props.justifyContent};
  align-items: ${(props) => props.alignItems}; */}
  flex-basis: ${(props) => props.flexBasis};
`;

const PrincipalTitle = styled.h1`
  font-family: "Allerta Stencil", arial;
  font-size: 20px;
  color: rgb(48, 48, 48);
  margin-left: 20px;
  flex-basis: ${(props) => props.flexBasis};
`;

const TiersTitle = styled.span`
  font-family: "Oswald", sans-serif;
  font-size: 15.125rem;
  font-weight: bold;
  margin-left: 20px;
  ${"" /* color: rgb(48, 48, 48); */}
  color: rgb(223, 223, 223);

  @media ${device.tablet} {
    font-size: 4em;
  }
`;
export {
  GlobalStyle,
  Container,
  CommunContainer,
  Items,
  Flex,
  PrincipalTitle,
  TiersTitle,
};
